<div *ngIf="iCompleteStepParameterizationDto?.petObjCategoria"
  class="flex justify-between text-[#787878] font-semibold">
  <h1>
    Placar - {{ iCompleteStepParameterizationDto!.petObjCategoria!.catTxNome }} - {{
    iCompleteStepParameterizationDto!.petTxNome }}
  </h1>

</div>


<div class="overflow-x-auto mb-8 custom-scroll">
  <table class="table-auto w-full bg-white rounded-2xl px-4 py-6 border-separate border-spacing-0 ">
    <thead class="text-[#787878] text-center">
      <tr>
        <!-- WO -->
        <th class="w-14"></th>
        <!-- Nome do time/participante -->
        <th class="w-40 text-left"></th>
        <!-- Sets Vencidos -->
        <th class="w-14 font-normal">Placar</th>
        <!-- Nome dos sets -->
        <ng-container *ngFor="let set of sets; let i = index">
          <th *ngIf="i < ettNrQtdPeriodo else nameEditable" class="w-14 max-w-[4.1rem] font-normal">
            {{ getPeriodName(i+1) }}
          </th>

          <ng-template #nameEditable>
            <th *ngIf="editingIndex !== i else nameInput" class="w-14 max-w-[4.1rem] font-normal"
              (dblclick)="enableNameEdit(i)">
              {{ getPeriodName(i+1) }}
            </th>
          </ng-template>
          <ng-template #nameInput>
            <th *ngIf="editingIndex !== undefined" class="w-14 max-w-[4.1rem] font-normal text-center"> <input
                sigecom-input [value]="getPeriodName(i+1)" (keydown.enter)="disableNameEdit()"
                (input)="setPeriodName(i+1, $event)" type="text" /></th>
          </ng-template>
        </ng-container>
        <!-- Botão + -->
        <th class="w-14"></th>
        <!-- Saldo -->
        <th class="w-16 font-normal">Saldo</th>
      </tr>
    </thead>
    <tbody>
      <!-- Linhas para cada time/participante -->
      <tr *ngFor="let item of teams.embListInscricaoDto!; let i = index;" class="text-center">
        <!-- Botão W.O. -->
        <td class="px-2" [ngClass]="{'pb-6' : i+1 < teams.embListInscricaoDto.length}">
          <button (click)="declareWOInAPeriod(item.iemNrId!)"
            class="w-14 h-12 bg-[#012169] hover:bg-[#011a56] text-white rounded-lg shadow-md font-medium">
            W.O
          </button>
        </td>

        <!-- Nome do time/participante -->
        <td class="text-center font-bold text-[#012169]" [ngClass]="{'pb-6' : i+1 < teams.embListInscricaoDto.length}">
          <div class="w-40">
            {{ abreviate(item.embateDto.inscricaoEtapaDto.ineObjInscricao.incTxResumo) }}
          </div>
        </td>

        <!-- Sets vencidos -->
        <td class="px-3" [ngClass]="{'pb-6' : i+1 < teams.embListInscricaoDto.length}">
          <div [ngClass]="{
              'border-green-500 text-green-600': getVencedorDosSets() === item.embateDto.inscricaoEtapaDto.ineObjInscricao.incNrId,
              'border-red-500 text-red-600': getVencedorDosSets() !== item.embateDto.inscricaoEtapaDto.ineObjInscricao.incNrId && getVencedorDosSets() !== null
            }" class="border w-14 h-14 rounded-lg flex items-center justify-center">
            {{ getSetsVencidosPorParticipante(item.embateDto.inscricaoEtapaDto.ineObjInscricao.incNrId) }}
          </div>
        </td>

        <!-- Inputs dos sets -->
        <td [ngClass]="{'pb-6' : i+1 < teams.embListInscricaoDto.length}" [attr.colspan]="sets.length">
          <div class="flex">
            <ng-container *ngFor="let set of sets; let j = index">
              <input class="w-14 mx-3 h-14 rounded-lg border border-[#7A7A7A] text-center" type="number"
                (ngModelChange)="onInputChange(item.iemNrId!, j+1, $event)" [ngModel]="getValor(item.iemNrId!, j+1)" />
            </ng-container>
          </div>
        </td>

        <!-- Botão de adicionar set (apenas uma vez na coluna lateral) -->
        <td (click)="adicionarSet()" class="h-full min-w-14 rounded-lg border border-gray-400  hover:bg-gray-200"
          *ngIf="i === 0" attr.rowspan="{{ teams.embListInscricaoDto!.length }}">
          <p class="text-xl font-bold text-[#7A7A7A] ">
            +
          </p>
        </td>

        <!-- Total por time -->
        <td class="px-6" [ngClass]="{'pb-6' : i+1 < teams.embListInscricaoDto.length}">
          <div
            class="w-14 px-2 h-14 flex items-center justify-center bg-[#ECEDF2] border border-[#7A7A7A] rounded-lg text-[#7A7A7A]">
            {{ getTotal(item.embateDto.inscricaoEtapaDto.ineObjInscricao.incNrId) }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="flex w-full justify-center">
  <sigecom-radio-toggle label="Placar definido" [selected]="teams.embBlResultadoDefinido"
    (selectedChange)="setEmbDefined($event)" />
</div>

<!-- Botões de controle -->
<div class="flex justify-between gap-4 mt-6">
  <button (click)="resetScoreboard()"
    class="flex-1 bg-[#FF3B30] hover:bg-red-600 text-white py-3 rounded-lg shadow-md flex items-center justify-center gap-2">
    <fa-icon class="text-lg" icon="trash"></fa-icon>
    <span class="text-lg font-medium">Resetar placar</span>
  </button>

  <button [disabled]="enableLoading" (click)="submit()"
    class="flex-1 bg-[#012169] hover:bg-[#011a56] text-white py-3 rounded-lg shadow-md flex items-center justify-center gap-2">
    <fa-icon *ngIf="!enableLoading" class="text-lg" icon="floppy-disk"></fa-icon>
    <span class="text-lg font-medium">{{!enableLoading ? 'Salvar Placar' : ''}} </span>


    <ng-container *ngIf="!enableLoading; else showLoading">
      <fa-icon *ngIf="icon && !invertIconPos" [icon]="icon"></fa-icon>

      <fa-icon *ngIf="icon && invertIconPos" [icon]="icon"></fa-icon>
    </ng-container>

    <ng-template #showLoading>
      <sigecom-circle-loading [sizeInRem]="1.5" color="white" />
    </ng-template>
  </button>
</div>

<style>
  .custom-scroll::-webkit-scrollbar {
    width: 6px;
    /* largura vertical */
    height: 4px;
    /* altura horizontal */
    scroll-margin-inline: 1rem;
  }

  .custom-scroll::-webkit-scrollbar-thumb {
    background-color: rgba(100, 100, 100, 0.5);
    border-radius: 10px;
  }

  .custom-scroll::-webkit-scrollbar-track {
    background: transparent;
  }
</style>